export default __webpack_public_path__ + "static/media/challengeCompletedModalDark.ff193317.png";